function getSystemTimezoneOffset() {
  // Why multiply with -1?
  // Because this returns negated value by default. Example we would expect
  // offset for IST to be 330 but below method returns -330.
  return new Date().getTimezoneOffset() * -1;
}

export default getSystemTimezoneOffset;
